import React, { useState, useEffect, Fragment, useRef } from 'react';
import Button from '@mui/material/Button';
import FieldNames from '../../defaults/FieldNames.json';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { emitCustomEvent } from 'react-custom-events';
import Events from '../../defaults/Events';
import PropTypes from 'prop-types';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { ButtonGroup, Popper, Grow, Paper, MenuItem, MenuList, Tooltip } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import './DetailsHeader.css';
import DetailsRequired from './DetailsRequired';
import DetailsEdited from './DetailsEdited';
import { useLocation } from 'react-router';
import { isFeaturePostFire } from '../../utils/FeatureHelper';
export default function DetailsProjectHeader({ project, closeDetail, mode, disableEdit, disableEditMessage, onSaveChanges, isSaveDisabled, disableDelete, onEditClicked, userInfo, saveDisabledMessage, chipClicked, chipClickedUnsaved }) 
{
  const [label, setLabel] = useState("");
  const [cancelDetailDialogOpen, setCancelDetailDialogOpen] = useState(false);
  const [openDeleteFeatureDialog, setOpenDeleteFeatureDialog] = useState(false);
  const [missingFields, setMissingFields] = useState(0);
  const [unsavedFields, setUnsavedFields] = useState(0);
  const [actionOpen, setActionOpen] = useState(false);
  const [actualsActionOpen, setActualsActionOpen] = useState(false);
  const anchorRef = useRef(null);
  const anchorRefActuals = useRef(null);
  const buttonStyle = { marginLeft: '10px', display: 'inline', height: '30px' }
  const [ isActuals, setIsActuals ] = useState(false);
  const location = useLocation();
  const [isArchived, setIsArchived] = useState('No');
  const [isCompleted, setIsCompleted] = useState(false);
  const [isPoint, setIsPoint] = useState(false);

  const handleActionToggle = () => {
    setActionOpen((prevOpen) => !prevOpen);
  };

  const handleActionClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setActionOpen(false);
  };

  const handleActualsActionToggle = () => {
    setActualsActionOpen((prevOpen) => !prevOpen);
  };

  const handleActualsActionClose = (event) => {
    if(anchorRefActuals.current && anchorRefActuals.current.contains(event.target)) {
      return;
    }
    setActualsActionOpen(false);
  }

  useEffect(() => 
  {
    let updatedLabel = (project && project.attributes) ? project.attributes[FieldNames.featureFields.name] : "";
    
    setLabel(updatedLabel);
  }, [project]);

  const onClose = () => {
    closeDetail(null);
    emitCustomEvent(Events.ClearModifiedLayer);
  }

  const closeCancelDetailDialog = () => 
  {
    setCancelDetailDialogOpen(false);
  }

  const closeDeleteFeatureDialog = () => {
    setOpenDeleteFeatureDialog(false);
  }

  const onEdit = () => {
    onEditClicked();
  }

  const anyMissingFields = () => {
    if(missingFields > 0 && mode === FieldNames.modes.edit) {
      return (
        <DetailsRequired chipClicked={chipClicked} missingFields={missingFields} />
      )
    } else {
      return (
        <Fragment></Fragment>
      )
    }
  }

  const anyUnsavedFields = () => {
    if(unsavedFields > 0 && mode === FieldNames.modes.edit) {
      return (
        <DetailsEdited chipClicked={chipClickedUnsaved} unsavedFields={unsavedFields} />
      )
    } else {
      return (
        <Fragment></Fragment>
      )
    }
  }

  const handleAgreeToAbandonFeature = () => 
    {
      const geoType = FieldNames.joinFeatureValues.polygon;
      const isPostFire = isFeaturePostFire(project?.attributes, true)
      setCancelDetailDialogOpen(false);
      closeDetail(null);
      const featureClass = FieldNames.classTypes.project;
      emitCustomEvent(Events.ClearGraphicsEvent, { geometryType: geoType, isPostFire: isPostFire, featureClass: featureClass });
      emitCustomEvent(Events.ClearModifiedLayer);
    }

  return (
    <div className="incident-details-header">
      <div className='incident-details-top'>
        {isArchived === FieldNames.yesNo.yes &&
          <h3 style={{color: 'red', whiteSpace: 'pre-wrap'}}>{label} - Archived</h3>
        }
        {isArchived !== FieldNames.yesNo.yes &&
          <h3 style={{whiteSpace: 'pre-wrap'}}>{label}</h3>
        }
        <div className="incident-details-header-actions">
          {(mode === FieldNames.modes.read && isArchived !== FieldNames.yesNo.yes) &&
            <Tooltip title={disableEdit ? disableEditMessage : ""} arrow>
              <span>
                <Button
                onClick={onEdit}
                color="primary"
                variant="outlined"
                style={buttonStyle}
                size="small"
                disabled={disableEdit}
                >
                  Edit
                </Button>
              </span>
            </Tooltip>
          }

          {mode === FieldNames.modes.edit &&
            <Tooltip title={saveDisabledMessage} placement='top'>
              <span>
                <Button
                onClick={onSaveChanges}
                color="primary"
                style={buttonStyle}
                disabled={isSaveDisabled}
                variant="outlined"
                size="small">Save</Button>
              </span>
            </Tooltip>
          }
          <Button
            onClick={onClose}
            variant="outlined"
            style={buttonStyle}
            size="small">Close</Button>
        </div>
      </div>
      <div className='incident-details-bottom'>
        {anyUnsavedFields()}
        {anyMissingFields()}
        <Dialog
          open={cancelDetailDialogOpen}
          onClose={closeCancelDetailDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {"Cancel New Project"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {"This project has not been saved, are you sure you want to discard it?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAgreeToAbandonFeature}>Yes</Button>
            <Button onClick={closeCancelDetailDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
        {/* <Dialog
          open={openDeleteFeatureDialog}
          onClose={closeDeleteFeatureDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
              {"Delete Project"}
            </DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {"This project will be removed, are you sure you want to delete it?"}
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={async() => { await handleAgreeToArchiveFeature() }}>Yes</Button>
            <Button onClick={closeDeleteFeatureDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog> */}
      </div>
    </div>
  );
}
